import { useHistory } from "react-router";

import AmplitudeProvider from "~/AmplitudeProvider";
import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useMutationRequest } from "../../../../../api/hooks";
import { kycPatch } from "../../../../../api/rest/onboarding";
import type { StepProps } from "../../session";
import Onfido from "./onfido";
import OnfidoWorkflow from "./onfidoWorkflow";
import Trulioo from "./trulioo";

const KYCStep = ({ session: { account, details } }: StepProps) => {
  const history = useHistory();
  const shouldUseWorkflow = useFeatureEnabled(
    FeatureFlags.ONFIDO_WORKFLOW_STUDIO,
  );
  const { refetchLiveAccounts } = useAccountContext();

  const { mutate: patchKYC } = useMutationRequest(() => kycPatch(account.id), {
    onSuccess: async () => {
      refetchLiveAccounts();

      setTimeout(() => history.push(Path.ROUTE_DASHBOARD), 2000);

      AmplitudeProvider.dispatchKYCComplete({
        details,
        liveAccount: account,
      });
    },
  });

  switch (account.kyc_provider) {
    case "onfido":
      if (shouldUseWorkflow) {
        return (
          <OnfidoWorkflow
            account={account}
            handleCompleted={() => patchKYC(null)}
          />
        );
      }
      return (
        <Onfido account={account} handleCompleted={() => patchKYC(null)} />
      );
    default:
      return (
        <Trulioo account={account} handleCompleted={() => patchKYC(null)} />
      );
  }
};

export default KYCStep;
